import React from "react";
import "./FirstAnimBlock.css";
import RoundedButton from "../RoundedButton/RoundedButton";
import AnimatedCloud from "./AnimatedCloud";

function FirstAnimBlock() {
  return (
    <div className="first-anim-block">
      <div className="left-block">
        <div className="hero-label">Cloud Development &amp; IT Services</div>
        <h1 className="text-perfect-partner">
          Empowering businesses to{" "}
          <span className="brand-gradient-text">build, scale, and ship</span>{" "}
          faster in the cloud
        </h1>
        <p className="hero-subtitle">
          From MVP to enterprise scale — we're your full-cycle development
          partner for cloud-native applications, data platforms, and digital
          products.
        </p>
        <div className="hero-buttons">
          <a href="#contact">
            <RoundedButton variant="filled">Let's Talk</RoundedButton>
          </a>
          <a href="#services" className="hero-secondary-link">
            View our services &rarr;
          </a>
        </div>
      </div>
      <div className="right-block">
        <AnimatedCloud />
      </div>
    </div>
  );
}

export default FirstAnimBlock;
